import './index.less';

import classNames from 'classnames';
import { useEffect } from 'react';

import { useFingerPrint } from '@/hooks/useFingerPrint';
import { useUserProfile } from '@/hooks/useUserProfile';
import { isMobile } from '@/utils/ua';

import { CreateApiBreadCrumb } from './comps/CreateApiBreadCrumb';
import { CreateApiForm } from './comps/CreateApiForm';

const CreateApiPage = () => {
  const { profile } = useUserProfile();

  const { fingerReport } = useFingerPrint();

  useEffect(() => {
    if (profile?.result?.id) {
      fingerReport('wf07', '0');
    }
  }, [profile]);

  return (
    <div
      className={classNames(
        'by-us-fe-main create-new-api-key',
        isMobile({ tablet: true }) && 'create-new-api-key-h5',
      )}
    >
      <CreateApiBreadCrumb />
      <CreateApiForm />
    </div>
  );
};

export default CreateApiPage;
